import { network } from '@utils'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export interface IWidgetSession {
  token: string | null
  country: string
  theme?: string | null
  luca_skills_and_yolo: boolean
}

const DEFAULT_COUNTRY = 'fi'

export const fetchWidgetSession = async (businessSlug?: string): Promise<IWidgetSession> => {
  const url = businessSlug
    ? `/auth/business/${businessSlug}/agent-session/`
    : '/auth/agent-session/'

  const { data, status } = await network.httpClient.request<IWidgetSession>({
    url,
    method: 'GET',
    validateStatus: () => true
  })

  if (status === 200 && data && typeof data.country === 'string') {
    return {
      token: data.token ?? null,
      country: data.country,
      theme: data.theme ?? null,
      luca_skills_and_yolo: data.luca_skills_and_yolo === true
    }
  }

  return { token: null, country: DEFAULT_COUNTRY, theme: null, luca_skills_and_yolo: false }
}

export const useWidgetSession = (
  enabled = true,
  businessSlug?: string
): UseQueryResult<IWidgetSession, unknown> =>
  useQuery({
    queryKey: [businessSlug || null, 'widget-session'],
    queryFn: () => fetchWidgetSession(businessSlug),
    enabled,
    staleTime: 60_000,
    retry: (retryCount, error: any) => {
      if (error?.status === 401) return false
      return retryCount < 2
    }
  })
